export const drawChain = (canvas, chain) => {
  
  Object.keys(chain).forEach((key) => {
    canvas
  });
};




// WEBPACK FOOTER //
// ./drawing.js